import { get } from 'lodash'

window.fbAsyncInit = function() {
  window.FB.init({
    appId            : get(window.settings, 'socialMedia.facebook.appId'),
    autoLogAppEvents : true,
    xfbml            : true,
    version          : 'v2.9'
  })
  window.FB.AppEvents.logPageView()
}

var initializeFacebookLogin = () => {
  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(window.document, 'script', 'facebook-jssdk'))
}


function initializeGoogleLogin(element, cb) {
  var gapi = window.gapi

  gapi.load('auth2', function() {
    var auth2 = gapi.auth2.init({
      client_id: window.settings.auth.googleClientId,
      cookiepolicy: 'single_host_origin',
    })
    auth2.attachClickHandler( element, {}, u => cb(null, u), e => cb(e))
  })
}

export default {
  initializeFacebookLogin: initializeFacebookLogin,
  initializeGoogleLogin: initializeGoogleLogin
}